module.exports = __webpack_public_path__ + "static/lisa-16c67122d5050a068beb3aba147ebb93.jpg";